function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TooltipDelay, TooltipHost } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { noop } from 'lodash-es';
const Tooltip = ({ children, tooltipHostProps = {}, onTooltipToggle = noop })=>{
    const tooltipId = useId('tooltip');
    const tooltipStyles = {
        content: {
            cursor: 'default'
        }
    };
    const tooltipProps = {
        styles: tooltipStyles
    };
    const calloutProps = {
        gapSpace: 5,
        isBeakVisible: false,
        setInitialFocus: false,
        dismissOnTargetClick: true
    };
    const onTooltipToggleHandle = (isTooltipVisible)=>{
        onTooltipToggle === null || onTooltipToggle === void 0 ? void 0 : onTooltipToggle(isTooltipVisible);
    };
    return /*#__PURE__*/ _jsx(TooltipHost, _object_spread_props(_object_spread({
        id: tooltipId,
        onTooltipToggle: onTooltipToggleHandle,
        delay: TooltipDelay.long,
        closeDelay: 0,
        tooltipProps: tooltipProps,
        calloutProps: calloutProps
    }, tooltipHostProps), {
        children: children
    }));
};
export default Tooltip;
